import { CheckoutMode } from '@afterpaytouch/portal-api/types'
import { AddressModeType, InitialData } from './checkout'

export const isDeferredShippingForPayMonthly = (checkoutMode: CheckoutMode | null | undefined, initial: InitialData): boolean => {
  if (checkoutMode !== CheckoutMode.EXPRESS) return false

  const isDigitalGood = initial.addressMode === AddressModeType.NO_ADDRESS && initial.buyNow && !initial.shippingOptionRequired
  const isBuyNowWithShippingOptions = initial.addressMode !== AddressModeType.NO_ADDRESS && initial.buyNow && initial.shippingOptionRequired

  return !isDigitalGood && !isBuyNowWithShippingOptions
}
